// extracted by mini-css-extract-plugin
export default {"input":"IdleStage_input__YR9df","bottom":"IdleStage_bottom__nEtK-"};